module.exports = __webpack_public_path__ + "static/media/doublebubble.34363e48.png";